import { getBankAccountsData, searchBankAccountData } from "@/Api/bankAccounts";
import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { ApiDataProps } from "@/pages/Tenants";
import { useEffect, useState } from "react";
import { TypePageActions } from "../Plans";
import { TableData } from "@/App/BankAccounts/Table";
import { AddBtn } from "@/App/BankAccounts/Add";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { Landmark } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";

export type TableDataProps = {
  id: number;
  uuid: string;
  name: string;
  surname: string;
  bank_id: number;
  bank_name: string;
  agency: string;
  account_number: string;
  bank_account_type_id?: number | string;
  is_active: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  unity_id?: string;
  unity?: {
    id: string;
    name: string;
  };
};

export const PageList = () => {
  const [listData, setListData] = useState({} as ApiDataProps<TableDataProps>);
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();

  useEffect(() => {
    (async () => {
      const { data } = await getBankAccountsData();
      setListData(data?.response);
      setState("production");
    })();
  }, []);

  const pageActions: TypePageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        setState("loading");
        const { data } = await getBankAccountsData(listData?.current_page + 1);
        setListData(data.response);
        setState("production");
      }
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        setState("loading");
        const { data } = await getBankAccountsData(listData?.current_page - 1);
        setListData(data.response);
        setState("production");
      }
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        setState("loading");
        const { data } = await getBankAccountsData(listData?.last_page);
        setListData(data?.response);
        setState("production");
      }
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-bank-accounts-list")}>
        <PageHeader
          icon={Landmark}
          title="Contas Bancarias"
          description="Gerencie suas contas bancarias"
        >
          <If condition={hasPermission("create-bank-account")}>
            <AddBtn updateFront={setListData} />
          </If>
        </PageHeader>
        <div className="flex flex-col gap-3">
          <SearchComponent
            updateFront={setListData}
            setState={setState}
            funcSearch={searchBankAccountData}
            placeholder="Pesquisar por nome"
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={5} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={setListData}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
